import "yup-phone-lite"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Card, CardBody, CardFooter, Button, Input, Checkbox } from "@nextui-org/react"

import { usePost } from "../../api/reactQueryCustomHooks.jsx"
import { MainContainer } from "../../components/index.js"
import { apiRoute, linksUrl } from "../../constants/enum.js"

function AddUserMaster() {
  const navigate = useNavigate()

  const { selectedClient } = useSelector((state) => state.clientMaster)
  const [errors, setErrors] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const [isApiUser, setIsApiUser] = useState(false)
    const [isActive, setIsActive] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    loginName: "",
    email_id: "",
    contact_no: "",
    password: "",
    confirm_password: "",
  })

  const onSuccessTasks = () => {
    navigate(linksUrl.userMaster.read)
  }
  const resetValues = () => { }

  const { isPending, mutate: addUserMaster } = usePost({
    url: apiRoute.userMaster.add,
    queryKey: "UserMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate First Name
    if (formData.firstName.trim() === "") {
      newErrors.firstName = "First Name is required"
    }

    // Validate Last Name
    if (formData.lastName.trim() === "") {
      newErrors.lastName = "Last Name is required"
    }

    // Validate Login Name
    if (formData.loginName.trim() === "") {
      newErrors.loginName = "Login Name is required"
    }

    // Validate Email Id
    if (formData.email_id.trim() === "") {
      newErrors.email_id = "Email Id is required"
    }

    // Validate Contact No
    if (formData.contact_no.trim() === "") {
      newErrors.contact_no = "Contact No is required"
    }

    // Validate Password No
    if (formData.password.trim() === "") {
      newErrors.password = "Password No is required"
    }

    // Validate Confirm Password No
    if (formData.confirm_password.trim() === "") {
      newErrors.confirm_password = "Confirm Password No is required"
    }

    // Validate Confirm Password No
    if (formData.confirm_password.trim() !== formData.password.trim()) {
      newErrors.confirm_password = "Confirm Password should be same as Password"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      addUserMaster({
        data: {
          client_code: selectedClient.client_code,
          firstName: formData.firstName,
          lastName: formData.lastName,
          loginName: formData.loginName,
          email_id: formData.email_id,
          contact_no: formData.contact_no,
          password: formData.password,
          confirm_password: formData.confirm_password,
          isApiUser: isApiUser ? 1 : 0,
          roleId:isAdmin?1:0,
          isActive:isActive?1:0
        },
      })
    }
  }

  const onClickPrevPage = () => {
    navigate(linksUrl.userMaster.read)
  }

  return (
    <MainContainer
      breadcrumbs={["Client Master", "User Master", "Add"]}
      pageName={"Add User"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
      headingCardProps={[
        ["Client", selectedClient.client_name, selectedClient.client_code],
      ]}
    >
      <Card className="max-w-[600px]" shadow="none" classNames="p-0">
        <form onSubmit={handleSubmit}>
          <CardBody className="p-0">
            <div className="flex flex-col gap-4 mx-2">
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="First Name"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.firstName}
                  errorMessage={errors?.firstName}
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  type="text"
                  label="Last Name"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.lastName}
                  errorMessage={errors?.lastName}
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  type="text"
                  label="Login Name"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.loginName}
                  errorMessage={errors?.loginName}
                  name="loginName"
                  value={formData.loginName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="Email Id"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.email_id}
                  errorMessage={errors?.email_id}
                  name="email_id"
                  value={formData.email_id}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  type="text"
                  label="Contact No."
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.contact_no}
                  errorMessage={errors?.contact_no}
                  name="contact_no"
                  value={formData.contact_no}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  label="Password"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.password}
                  errorMessage={errors?.password}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
                <Input
                  label="Confirm Password"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.confirm_password}
                  errorMessage={errors?.confirm_password}
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Checkbox size="md"
                  classNames={{ "label": "text-green-700 text-md font-semibold" }}
                  className="py-1 px-2 mt-2  " color={"success"} isSelected={isApiUser}
                  onValueChange={setIsApiUser} >IsApiUser</Checkbox>

                <Checkbox size="md"
                  classNames={{ "label": "text-green-700 text-md font-semibold" }}
                  className="py-1 px-2 mt-2  " color={"success"} isSelected={isAdmin}
                  onValueChange={setIsAdmin} >Is Admin</Checkbox>

                   <Checkbox size="md"
                  classNames={{ "label": "text-green-700 text-md font-semibold" }}
                  className="py-1 px-2 mt-2  " color={"danger"} isSelected={isActive}
                  onValueChange={setIsActive} >Is Active</Checkbox>
              </div>
            </div>
          </CardBody>
          <CardFooter>
            <Button color="primary" type="submit" isLoading={isPending}>
              Add User
            </Button>
          </CardFooter>
        </form>
      </Card>
    </MainContainer>
  )
}

export default AddUserMaster
